import { Button, Table, Input, Row, Col, Modal, message, Typography, Flex, Tooltip, Card } from "antd";
import { useEffect, useRef, useState, } from "react";
import Highlighter from 'react-highlight-words';
import api from "../../API";
import { DeleteOutlined, SearchOutlined, EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
const btnIconList = ['button_1_icon','button_2_icon','button_3_icon','button_4_icon','button_5_icon']

function TemplateList({tplType}){
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [inUseTplIds, setInUseTplIds] = useState([]);
  const originalCampaigns = useRef([]);
  const tableDataOnScreen = useRef([]);
  const originalTableData = useRef([]);
  const columns = [
    {
      title: "Name",
      dataIndex: "templateCode",
      width: 300,
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Content",
      dataIndex: "text",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Created At",
      dataIndex: "createdDate",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: 'Action',
      key: 'action',
      width: 105,
      align: 'center',
      render: (_, record) => (
        <Flex justify="space-around" align="center">
          <Button 
            type="primary" 
            icon={<EditOutlined/>} 
            onClick={() => navigate(
              `/template/${tplType}s/edit`,
              {state: originalTableData.current.find(obj => obj.id === record.key)}
            )}>
          </Button>
          <Tooltip title={inUseTplIds.includes(record.key) && "Cannot delete because this template is currently in use in some campaigns"}>
            <Button 
              type="primary" danger 
              icon={<DeleteOutlined/>}
              disabled = {inUseTplIds.includes(record.key)}
              onClick={() => {
                Modal.confirm({
                    title: 'Confirm deletion',
                    content: `Are you sure you want to delete this template?`,
                    onOk() {handleRemoveRow(record.key)},
                    maskClosable: true
                })}}></Button>
          </Tooltip>
        </Flex>),
    }
  ];

  useEffect(() => {
    api.list_all_campaigns(user?.userId)
    .then(campaigns => {
      originalCampaigns.current = campaigns;
      setInUseTplIds(campaigns.reduce((prevArr, {template_type, templateId}) => template_type === tplType? [...prevArr, templateId]: prevArr ,[]));
    })
    .catch(err => message.error(err.message));
  },[])

  useEffect(() => {  
    if(originalCampaigns.current.length) setInUseTplIds(originalCampaigns.current.reduce((prevArr, {template_type, templateId}) => template_type === tplType? [...prevArr, templateId]: prevArr ,[]));
    setLoading(true);
    api.list_all_templates(tplType, user?.userId)
    .then(data => {
      originalTableData.current = [...data];
      data = data.map(dataTemplate=>{
        return { 
          key: dataTemplate.id, 
          templateCode: dataTemplate.templateCode,
          text: (dataTemplate.template_text? dataTemplate.template_text: dataTemplate.header_title_text),
          createdDate: (new Date(dataTemplate.createdDate)).toLocaleDateString('en-CA')
        }});
      tableDataOnScreen.current = [...data];
      setDataSource(tableDataOnScreen.current); 
    })
    .catch(err => message.error(err.message))
    .finally(() => setLoading(false))
    }, [tplType]);
  
    function handleSearchInfo(e) {
      if(e.target.value === '') {
        setSearchText(e.target.value);
        setDataSource(tableDataOnScreen.current);
      }
      else {
        const searchData = tableDataOnScreen.current.filter((o) => Object.keys(o).slice(1).some((k) => o[k] && String(o[k])
        .toLowerCase()
        .includes(e.target.value.toLowerCase())));
        setSearchText(e.target.value);
        setDataSource(searchData);
      }
    }

    async function handleRemoveRow(removeKey) {
      try {
        setLoading(true);
        const removeRecord = originalTableData.current.filter(removeRecord => removeRecord.id === removeKey)
        const responseRemove = await api.delete_templateByID(removeKey, tplType);
        if(tplType === 'consultant') removeRecord[0].template_file && await api.deleteFiles([JSON.parse(removeRecord[0].template_file).url.split("/").pop()])
        else {  
          await api.deleteFiles([
            JSON.parse(removeRecord[0].banner_url).url.split("/").pop(),
            ...btnIconList.reduce((prevArr, btnIcon) => removeRecord[0][btnIcon]? [...prevArr, JSON.parse(removeRecord[0][btnIcon]).url.split("/").pop()]: prevArr,[])
          ]);
        }
        tableDataOnScreen.current = tableDataOnScreen.current.filter(record => record.key !== removeKey);
        originalTableData.current = originalTableData.current.filter(record => record.id !== removeKey);
        setDataSource(tableDataOnScreen.current)
        message.success(responseRemove.message)
      } catch (error) {
        message.error(error.message)
      } finally {
        setLoading(false);
      } 
    }
  
    return (
    <Card 
      style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
      title={
        <Typography.Title level={5} style={{margin:0}}>{tplType.charAt(0).toUpperCase() + tplType.slice(1)}s</Typography.Title>
      }
      loading={loading}
      extra={ 
      <Link to={`/template/${tplType}s/new`}>
        <Button type="primary" style={{padding:15}} icon={<PlusCircleOutlined/>}>
            New Template
        </Button>
      </Link>
    }
    >
        <Row gutter={[16,16]}  align="middle">
          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Input 
                placeholder="Input search text"
                allowClear
                onChange={handleSearchInfo}
                suffix={<SearchOutlined />}/>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Table  
              bordered
              scroll={{x: 1000}}
              columns= {columns} 
              style={{marginTop: 16, width: '100%'}} 
              dataSource={dataSource}
              loading={loading}
              pagination={{
                position: ["bottomCenter"],
                showSizeChanger: false, // Disable page size changer
                pageSize: 10, 
                showTotal: () => `Total: ${dataSource.length} items`
              }}
            />
          </Col>
        </Row>
      </Card>
    )
}

export default TemplateList;